import { RotatingCaret } from "@/components/generalUI/RotatingCaret";
import { motion } from "framer-motion";
import {
  icons,
  colors,
  SANS_2,
  transition,
  ellipsis,
  UI_BODY_SEMIBOLD_SM_DF,
  colors2,
  TooltipV2,
} from "oolib";
import { applyBlackOverlayOnHover } from "oolib/dist/v2/themes/utils/baseStyling";
import { ChartScatter, FileText, Highlighter } from "@phosphor-icons/react";
import React from "react";

import styled, { css } from "styled-components";

const { CaretRight } = icons;
// Nav icons oolib's set doesn't carry, by the same name the config uses.
const EXTRA_ICONS = { ChartScatter, FileText, Highlighter };

const StyledSidebarButton = styled.button`
  border: none;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? colors2.primaryContainer : "unset"};
  color: ${({ active }) => (active ? colors2.white : colors2.black)};
  position: relative;
  ${applyBlackOverlayOnHover({ borderRadius: "0.6rem", zIndex: 0 })}
  border-radius: 0.6rem;
  padding: 0.8rem;
  // ${transition("padding")};
  /* height: 4rem; */
  width: 100%;
  min-width: 0;
  /* padding: 0 2rem; */
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const STYLED_UI_BODY_SEMIBOLD_SM_DF = styled(UI_BODY_SEMIBOLD_SM_DF)`
  overflow: clip;
  text-align: left;
  white-space: nowrap;
`;

export const ButtonPrimarySidebarNav = ({
  value,
  display,
  onClick,
  active,
  icon,
  sidebarOpen,
  style,
  isAccordion,
  accordionClosed,
  ...props
}) => {
  const Icon = icon && (icons[icon] || EXTRA_ICONS[icon]);

  const buttonComp = (
    <StyledSidebarButton
      style={style}
      active={active}
      onClick={onClick}
      sidebarOpen={sidebarOpen}
      {...props}
    >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.6rem",
            width: "100%",
            zIndex: 1,
          }}
        >
          {Icon && (
            <div style={{ flexShrink: 0, position: "relative" }}>
              <Icon size={16} weight="bold" />
              {isAccordion && (
                <motion.div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "-2.5rem",
                    transform: "translateY(-50%)",
                  }}
                  animate={{ opacity: sidebarOpen === false ? 1 : 0 }}
                  transition={{ type: "tween", ease: "easeOut" }}
                >
                  <CaretRight size={16} />
                </motion.div>
              )}
            </div>
          )}
          <motion.div
            style={{ minWidth: 0 }}
            initial={{ opacity: 1 }}
            animate={{ opacity: sidebarOpen ? 1 : 0 }}
            transition={{ type: "tween", ease: "easeOut", duration: 0.15 }}
          >
            <STYLED_UI_BODY_SEMIBOLD_SM_DF>
              {display}
            </STYLED_UI_BODY_SEMIBOLD_SM_DF>
          </motion.div>
        </div>
        {isAccordion && (
          <RotatingCaret
            position={accordionClosed.includes(value) ? "down" : "up"}
            opacity={sidebarOpen ? 1 : 0}
          />
        )}
      </StyledSidebarButton>
  );

  // Only show the tooltip when the sidebar is collapsed, since the label
  // is hidden in that state. When expanded, the label is visible inline.
  return sidebarOpen === false ? (
    <TooltipV2 text={display} placement="right" wrapperDisplay="block">
      {buttonComp}
    </TooltipV2>
  ) : (
    <div>{buttonComp}</div>
  );
};
